module.exports = "/lucky-balls/img/green-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/green-ball.png
// module id = 99
// module chunks = 0